<template>
  <div class="content">
    <div class="swiper" :class="$vuetify.breakpoint.mobile ? 'mobileSwiper' : ''" v-if="viewType">
        <carousel-3d
        :animationSpeed="1000"
        :autoplay="true"
        :autoplayTimeout="3000"
        :disable3d="true"
        width="475"
        :height="carouselHeight"
      >
        <slide v-for="(item, i) in carouselList" :index="i" :key="i">
            {{lang == 'zh'?item.picturesZhCn:(item.picturesEnUs?item.picturesEnUs:item.picturesZhCn)}}
          <template slot-scope="obj" >
            <div :class="obj.isCurrent ? 'swiperBg':'op swiperBg'" style="height:100%">
                <div class="mask" v-if="!obj.isCurrent"></div>
                <img :src="lang == 'zh'?item.picturesZhCn:(item.picturesEnUs?item.picturesEnUs:item.picturesZhCn)" />
            </div>
          </template>
        </slide>
      </carousel-3d>
    </div>
    <div class="storeList" :class="$vuetify.breakpoint.mobile ? 'w_100' : 'pb_90' ">
        <div class="storeDetail" v-for="(item,index) in storeList" :key="index">
            <img class="storeImg" :src="lang=='zh'?item.picturesZhCn:(item.picturesEnUs?item.picturesEnUs:item.picturesZhCn)">
            <div style="position:relative" :class="$vuetify.breakpoint.mobile ? '' : 'pcDetailBox' ">
                <div class="storeHeader">
                    <span class="storeName">{{lang == 'zh' ? item.contentNameZhCn : (item.contentNameEnUs?item.contentNameEnUs:item.contentNameZhCn)}}</span>
                    <div class="time" v-for="(v,i) in item.extras" :key="i" v-show="(v.key == 'validTime' && ((lang == 'zh'&&v.keyType == 'Zh')|| (lang == 'en'&&v.keyType == 'En')) )">
                        {{ v.content }}
                    </div>
                </div>
                <span class="storeContent" v-html="lang == 'zh' ? item.contentZhCn : (item.contentEnUs?item.contentEnUs:item.contentZhCn)"></span>
                <!-- <span class="line"></span> -->
                <div :class="$vuetify.breakpoint.mobile ? 'detailContent m-detailContent' : 'detailContent' ">
                    <div v-for="(v,i) in item.extras" :key="i" class="adressDetail">
                        <span v-if="v.key == 'adress'&& ((lang == 'zh'&&v.keyType == 'Zh')|| (lang == 'en'&&v.keyType == 'En')) ">
                            <img src="../../assets/images/adress.png">{{v.content}}
                        </span>
                        <span v-if="v.key == 'phone'&& ((lang == 'zh'&&v.keyType == 'Zh')|| (lang == 'en'&&v.keyType == 'En')) ">
                            <img src="../../assets/images/phone.png">{{v.content}}
                        </span>
                        <span v-if="v.key == 'businessHours'&& ((lang == 'zh'&&v.keyType == 'Zh')|| (lang == 'en'&&v.keyType == 'En')) ">
                            <img src="../../assets/images/bussiness.png">{{v.content}}
                        </span>
                    </div>
                    <span class="line"></span>
                </div>
                
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import channelsApi from '../../api/channels'
import izh from "../../i18n/zh";
import ien from "../../i18n/en";
// 引入Carousel3d
import { Carousel3d, Slide } from 'vue-carousel-3d'
  export default {
    name: 'channels',
    components: {
        Carousel3d,
        Slide
    },
    data: () => ({
        viewType:false,
        carouselList:[],
        storeList: [],
        carouselHeight: ''
    }),
    watch:{
      '$route.query.sectionCode'(val){
        this.getData();
      },
    },
    computed:{
        lang(){
            return this.$i18n.locale;
        }
    },
    methods:{
        async getData(){
            let { data: storeData } = await channelsApi.getStoreItem(this.$route.query.sectionCode || '');
            if( storeData && storeData[0]?.children ){
                if( storeData[0].children[0]?.contents ){
                    this.carouselList = [];
                    let maxHeight = -1,maxWidth = -1;
                    storeData[0].children[0].contents.forEach(item => {
                        this.carouselList.push( { picturesZhCn: item.picturesZhCn, picturesEnUs: item.picturesEnUs })
                        let img_url = this.lang == 'zh' ? item.picturesZhCn : item.picturesEnUs;
                        // 创建对象zh
                        let img = new Image();
                        // 改变图片的src
                        img.src = img_url;
                        img.onload = () =>{
                            maxHeight = (img.height>maxHeight) ? img.height : maxHeight;
                            maxWidth = (img.width>maxWidth) ? img.width : maxWidth;
                        }
                    });
                    //保证图片都能获取到
                    let timer = setInterval(() => {
                        this.carouselHeight = maxHeight ? maxHeight/(maxWidth/475) : 0;
                        if( maxHeight != -1 ) clearInterval(timer);
                    }, 100);
                }
                if( storeData[0].children[1].contents ){
                    this.storeList = storeData[0].children[1].contents.map(v=>{
                        return {
                            ...v,
                            extras: JSON.parse(v.extras)
                        }
                    });
                }
            }
            this.viewType = true;
        }
    },
    async created(){
      await this.getData();
    }
  }
</script>
<style lang="scss" scoped>
    .swiper{
        width: 100%;
        height: 100%;
        img{
            height: auto!important;
        }
    }
    .mobileSwiper{
        ::v-deep .carousel-3d-slider,::v-deep .carousel-3d-slide{
            width: 100vw!important; 
        }
    }
    
    .op{
        opacity: 0.9;
    }
    .swiperBg{
        z-index: 999;
        position: relative;
        display: flex;
        .mask{
            position: absolute;
            z-index: 999;
            height: 100%;
            width: 100%;
            background: rgba($color: #000000, $alpha: 0.5);
        }
        img{
            z-index: 998;
            width: 100%;
            height: 100%;
        }
    }
    .w_100{
        width: 100%!important;
        margin: 0!important;
    }
    .storeList{
        width: 70%;
        margin-left: 15%;
        margin-top: -20px;
        display: flex;
        flex-wrap: wrap;
        padding-left: 3%;
        justify-content: center;
        padding-top: 20px;
        background: #f7f9f8;
        img{
            width: 350px;
            height: 250px;
            margin-right: 20px;
        }
        .storeDetail{
            margin-bottom: 10px;
            div{
                padding-top: 5px;
                // width: 50%;
            }
            .pcDetailBox{
                width: 50%;
            }
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            justify-content: space-around;
            margin-bottom: 30px;
            .storeImg{
                width: 29rem;
                height: 18rem;
                min-width: 290px;
                min-height: 180px;
            }
            .storeHeader{
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                justify-content: space-between;
                align-items: center;
                .storeName{
                    font-weight: 700;
                    font-size: 20px;
                    width: 100%;
                }
                .time{
                    margin-top: 10px;
                    background: #ede9e8;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 20px;
                    color: #1f72b9;
                    font-size: 14px;
                    padding: 0px 8px;
                }
            }   
            .storeContent{
                font-size: 14px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin: 20px 0;
                width: 29rem;
            }
            .detailContent{
                position: absolute;
                bottom: 0;
                width: 100%;
            }
            .m-detailContent{
                position: relative;
            }
            .line{
                height: 2px;
                width: 100%;
                background: #ebedec;
                display: block;
                margin: 10px auto;
                
            }
            .adressDetail{
                display: flex;
                flex-direction: column;
                font-size: 14px;
                img{
                    width: 13px;
                    height: 15px;
                    vertical-align:text-top
                }
            }
        }
    }
    .pb_90{
        padding-bottom: 90px;
    }

    // ::v-deep.carousel-3d-slider,.carousel-3d-slide,.carousel-3d-slide{
    //     height: 100%!important; 
    // }
</style>
